export default __webpack_public_path__ + "static/media/OpenSans-Light.55d5015c.ttf";